module["exports"] = [
  "#{prefix} #{first_name} #{last_name}",
  "#{first_name} #{nobility_title_prefix} #{last_name}",
  "#{first_name} #{last_name}",
  "#{first_name} #{last_name}",
  "#{first_name} #{last_name}",
  "#{first_name} #{last_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de/name/name.js
// module id = 929
// module chunks = 0